import { HttpClient } from '@angular/common/http';
import { NgxComponentsConfig } from '@app/ngx-components/ngx-components.config';

// Modules
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  APP_INITIALIZER,
  Injector,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// Services
import { RxMutationService } from '@app/ngx-components/services/rx-mutation.service';
import { ScreenCaptureService } from '@app/ngx-components/services/screen-capture.service';
import { Logger } from '@app/ngx-components/services/logger.service';

// Angular Material
import { heartBeatFactory } from '@app/ngx-components/Initializers/heart-beat.initializer';

/**
 * Platform common components and services library.
 *
 * @export
 */
@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NgxComponentsModule {
  /**
   * `forRoot()` method returns a `ModuleWithProviders` object which provides
   * `root` modules with the shared service instances.
   */
  static forRoot(config?: NgxComponentsConfig): ModuleWithProviders<NgxComponentsModule> {
    return {
      ngModule: NgxComponentsModule,
      providers: [
        RxMutationService,
        ScreenCaptureService,
        Logger,
        { provide: 'config', useValue: config },
        {
          provide: APP_INITIALIZER,
          useFactory: heartBeatFactory,
          deps: ['config', Injector, HttpClient],
          multi: true,
        },
      ],
    };
  }
}
